<template>

  <Header
    label="Tickets für"
    :headline="event.name"
  />

  <section class="bg-white py-20">
    <div class="container lg:flex lg:space-x-20">
      <div class="flex-none lg:w-1/3 mb-8">
        <div class="inline-block bg-white p-1 rounded-md shadow-md max-w-sm w-full">
          <img
            v-if="image"
            class="lazy block rounded bg-gray-100 w-full h-auto"
            :data-src="image.url"
            :height="image.height"
            :width="image.width"
            :alt="image.metadata?.alt ?? event.name"
          >
          <div v-else class="w-screen pb-[100%] rounded bg-gray-100 max-w-full"></div>
        </div>
      </div>
      <div class="flex-1 max-w-2xl">
        <h1 class="text-2xl text-blue-500 font-bold mb-4 mt-4">{{ event.name }}</h1>
        <p v-if="event.description" class="text-lg" v-html="event.description"></p>
        <hr class="border-gray-300 my-8">
        <EventTickets
          :event="event"
          :date="date"
        />
      </div>
    </div>
  </section>

</template>

<script>
import Layout from 'Web/Layouts/WithCart.vue';
import EventTickets from 'Web/Shared/EventTickets.vue';
import Header from 'Web/Shared/Header.vue';
import useMeta from '@/compose/meta';
import { computed } from 'vue';

export default {
  inheritAttrs: false,
  layout: Layout,
  components: {
    EventTickets,
    Header,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
    date: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const { assign } = useMeta();

    assign({ title: `DAS DA-Onlineshop - ${props.event.name}` });

    const image = computed(() => props.event.poster ?? props.event.cover);

    return {
      image,
    }
  }
}
</script>
